import React from 'react';
import { GlobeIcon } from '@radix-ui/react-icons';
import { useI18n } from '../i18n';

/**
 * A native <select> on purpose: it is keyboard accessible, works on every
 * phone without a custom popover, and reads correctly to screen readers.
 * Options are labelled in their own language - someone looking for their
 * language is looking for "Deutsch", not "German".
 */
const LanguageSelector = () => {
  const { lang, setLang, languages, t } = useI18n();

  return (
    <div className="lang-select">
      <GlobeIcon aria-hidden="true" />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        aria-label={t('nav.language')}
      >
        {languages.map((l) => (
          <option key={l.code} value={l.code}>
            {l.endonym}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
